module.exports = __webpack_public_path__ + "static/media/plum.d34c58f7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/space-gray-aluminum-case/plum.jpeg
// module id = 2037
// module chunks = 0